import { render, staticRenderFns } from "./campaignmail_unsubscribe.vue?vue&type=template&id=cd28aeca"
import script from "./campaignmail_unsubscribe.vue?vue&type=script&lang=js"
export * from "./campaignmail_unsubscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports